import React from "react";
import { cn } from "../../lib/utils";

/** 끊김 없이 흐르는 텍스트 띠 (콘텐츠를 2벌 렌더해 -50% 이동) */
export default function Marquee({ items, className, itemClassName, separator = "◆", duration = 34, reverse = false }) {
	const track = [...items, ...items];

	return (
		<div className={cn("mask-fade-x relative flex overflow-hidden", className)}>
			<div
				className="animate-marquee pause-on-hover flex shrink-0 items-center gap-8 pr-8"
				style={{ animationDuration: `${duration}s`, animationDirection: reverse ? "reverse" : "normal" }}
			>
				{track.map((item, i) => (
					<span key={`${item}-${i}`} className={cn("flex shrink-0 items-center gap-8", itemClassName)}>
						{item}
						<span className="text-accent/50">{separator}</span>
					</span>
				))}
			</div>
		</div>
	);
}
